import React from "react";
import {
  FaShieldAlt,
  FaRocket,
  FaCogs,
  FaHeadset,
  FaUserShield,
} from "react-icons/fa";

function GetYourCrypto() {
  return (
    <>
      <div
        className="brand-style-two-area default-padding bg-theme text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-15.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Get Your Crypto Wallet Mobile App Developed by Us
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="brand-style-two-items">
                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Secure Development Practices</h5>
                  <div className="info d-flex flex-column items-center">
                    <div className="logo-icon">
                      <FaShieldAlt size={50} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Fast Deployment</h5>
                  <div className="info d-flex flex-column items-center">
                    <div className="logo-icon">
                      <FaRocket size={50} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Customized Solutions</h5>
                  <div className="info d-flex flex-column items-center">
                    <div className="logo-icon">
                      <FaCogs size={50} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Post-Launch Support</h5>
                  <div className="info d-flex flex-column items-center">
                    <div className="logo-icon">
                      <FaHeadset size={50} />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Property</h5>
                  <div className="info d-flex flex-column items-center">
                    <div className="logo-icon">
                      <FaUserShield size={50} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GetYourCrypto;
